module.exports = __webpack_public_path__ + "img/37560-042.621b7bfd.jpg";